import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../wt-storage.service";
import { KasaCloseComponent } from "./kasa-close/kasa-close.component";
import { KasaOpenComponent } from "./kasa-open/kasa-open.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";


@Component({
  selector: 'app-kasa',
  templateUrl: './kasa.component.html',
  styleUrls: ['./kasa.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class KasaComponent implements OnInit {

  public isLoaded: boolean = false;
  public currentKasa: Kasa;
  selectedService: Kasa;
  public services: Kasa[];


  constructor(private readonly changeDetectionRef:ChangeDetectorRef,public readonly localCache:WtStorageService, private readonly modalService: NgbModal,public client:KasaClient){

  }

  ngOnInit(): void {

    this.LoadData();

  }


  private LoadData() {
        this.client.getList().subscribe((allServices: Kasa[]) => {
            this.services = allServices;
            this.isLoaded = true;
            this.currentKasa = this.localCache.getkasa();
            this.changeDetectionRef.detectChanges();
        });
    }

  public onSelected(service: Kasa){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: Kasa):boolean{
   return this.selectedService == service;
 }

  public onKasaOpen():void{

    let modalRef = this.modalService.open(KasaOpenComponent);
    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();
    });
  }

  public onKasaClose(): void {

    let modalRef = this.modalService.open(KasaCloseComponent);
    modalRef.componentInstance.kasa = this.currentKasa;

    modalRef.componentInstance.onClose().subscribe(r => {

      this.LoadData();
    });

  }

  public getDate(item: Date): string {
       if (item.getFullYear().toString() == '0001' || item.getFullYear().toString() =='1') {
      return '';
    }

    return DateHelper.GetFormattedDate(item);
  }
}

